import React from 'react';
import PropTypes from 'prop-types';
import PrimaryButton from '../../buttons/PrimaryButton';
import SecondaryButton from '../../buttons/SecondaryButton';
import ButtonGroup from './css';

const NextPreviousButtons = (props) => {
  const {
    currentStep, totalSteps, isValid, previousObj, nextObj, submitObj, onlyNext, reviewStep, noMargins,
  } = props;

  if (currentStep === reviewStep) {
    return null;
  }

  if (onlyNext) {
    return (
      <ButtonGroup className="has-only-child" noMargin={noMargins}>
        <PrimaryButton
          type={(nextObj.type) ? nextObj.type : 'button'}
          label={nextObj.label}
          onClick={(nextObj.action) ? nextObj.action : null}
          disabled={nextObj.disabled}
          showArrow
        />
      </ButtonGroup>
    );
  }

  if (currentStep === 0) {
    return (
      <ButtonGroup className="has-only-child">
        <PrimaryButton
          type="button"
          label={nextObj.label}
          onClick={nextObj.action}
          disabled={nextObj.disabled}
          showArrow
        />
      </ButtonGroup>
    );
  }

  if (currentStep === totalSteps && isValid) {
    return (
      <ButtonGroup className="has-children">

        <SecondaryButton
          type="button"
          label={previousObj.label}
          onClick={previousObj.action}
          showArrow
          isIconLeftPosition
        />
        <PrimaryButton
          type="submit"
          label={submitObj.label}
        />

      </ButtonGroup>
    );
  }

  return (
    <ButtonGroup className="has-children">

      <SecondaryButton
        type="button"
        label={previousObj.label}
        onClick={previousObj.action}
        showArrow
        isIconLeftPosition
      />
      <PrimaryButton
        type="button"
        label={nextObj.label}
        onClick={nextObj.action}
        disabled={nextObj.disabled}
        showArrow
      />

    </ButtonGroup>
  );
};

NextPreviousButtons.propTypes = {
  currentStep: PropTypes.number,
  totalSteps: PropTypes.number,
  isValid: PropTypes.bool,
  previousObj: PropTypes.object,
  nextObj: PropTypes.object,
  submitObj: PropTypes.object,
  onlyNext: PropTypes.string,
  reviewStep: PropTypes.number,
  noMargins: PropTypes.string,
};

export default NextPreviousButtons;
